import React from "react";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import WhatCanYouAutomate from "@/components/site/WhatCanYouAutomate";
import ExperienceTeaser from "@/components/site/ExperienceTeaser";
import HowItWorks from "@/components/site/HowItWorks";
import WhyGoSmartNest from "@/components/site/WhyGoSmartNest";
import Testimonials from "@/components/site/Testimonials";
import usePageTitle from "@/lib/usePageTitle";

export default function Home() {
    usePageTitle("GoSmartNest — Smart Home Automation for Modern Indian Homes");
    return (
        <div data-testid="home-page">
            <Hero />
            <TrustStrip />
            <ExperienceTeaser />
            <WhatCanYouAutomate />
            <HowItWorks />
            <WhyGoSmartNest />
            <Testimonials />
        </div>
    );
}
